<ng-container *ngIf="getWorkshops().length > 0">
    <div class="navigate-direction"><button mat-button class="prev" (click)="prev();" *ngIf="getPrevWorkshop() != null">Prev</button></div>
    <!--<div><button mat-button class="burger" (click)="openDialog()"><mat-icon>menu</mat-icon></button></div>-->
    <div class="navigate-direction"><button mat-button class="next" (click)="next();" *ngIf="getNextWorkshop() != null">Next</button></div>
</ng-container>